import { Pipe, PipeTransform } from '@angular/core';
import { LanguageTranslateService } from '../services/language-translate.service';

@Pipe({
  name: 'languageName',
})
export class LanguageNamePipe implements PipeTransform {
  constructor(private languageTranslateService: LanguageTranslateService) {}

  /**
   * translate the string and return the suitable language
   * @param value
   * @param args
   * @returns
   */
  transform(value: any, ..._args: unknown[]): string {
    return this.languageTranslateService.translate(value);
  }
}
